// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "国际私法",
        "tec": "牛玉璞",
        "week": "1-12周",
        "add": "教学楼D座225经管"
      },
      {
        "sub": "劳动与创造",
        "tec": "于瑶",
        "week": "14周",
        "add": "教学楼D座313文法"
      }
    ],
    [
      {
        "sub": "环境资源法",
        "tec": "郑萍",
        "week": "1-12周",
        "add": "教学楼D座225经管"
      },
      {
        "sub": "劳动与创造",
        "tec": "于瑶",
        "week": "14周",
        "add": "教学楼D座313文法"
      }
    ],
    {
      "sub": "知识产权法",
      "tec": "马喆",
      "week": "1-12周",
      "add": "教学楼D座327经管"
    },
    0,
    0
  ],
  "2": [
    {
      "sub": "法律职业伦理",
      "tec": "赵君",
      "week": "1-12周",
      "add": "教学楼D座327经管"
    },
    {
      "sub": "担保法律实务",
      "tec": "杨继慧",
      "week": "1-8周",
      "add": "教学楼D座222经管"
    },
    {
      "sub": "就业创业指导",
      "tec": "王倩",
      "week": "2-6周",
      "add": "教学楼D座426经管"
    },
    {
      "sub": "国家安全教育",
      "tec": "李进",
      "week": "9-12周",
      "add": "教学楼A座321电力"
    },
    0
  ],
  "3": [
    [
      {
        "sub": "知识产权法",
        "tec": "马喆",
        "week": "1-12周",
        "add": "教学楼D座325经管"
      },
      {
        "sub": "劳动与创造",
        "tec": "于瑶",
        "week": "14周",
        "add": "教学楼D座313文法"
      }
    ],
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "李芗霓王树平",
        "week": "1-8周",
        "add": "图书馆1楼党史+网络数字教育基地"
      },
      {
        "sub": "社会治理概论",
        "tec": "张梦琪",
        "week": "9-12周",
        "add": "教学楼D座325经管"
      },
      {
        "sub": "劳动与创造",
        "tec": "于瑶",
        "week": "14周",
        "add": "教学楼D座313文法"
      }
    ],
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "环境资源法",
      "tec": "郑萍",
      "week": "1-12周",
      "add": "教学楼D座225经管"
    },
    {
      "sub": "国际私法",
      "tec": "牛玉璞",
      "week": "1-12周",
      "add": "教学楼D座225经管"
    },
    0,
    {
      "sub": "法律职业伦理",
      "tec": "赵君",
      "week": "1-12周",
      "add": "教学楼D座225经管"
    },
    0
  ],
  "5": [
    {
      "sub": "证据运用实务",
      "tec": "马喆",
      "week": "1-8周",
      "add": "教学楼D座325经管"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "李芗霓王树平",
        "week": "1-8周",
        "add": "图书馆1楼党史+网络数字教育基地"
      },
      {
        "sub": "社会治理概论",
        "tec": "张梦琪",
        "week": "9-12周",
        "add": "教学楼D座325经管"
      }
    ],
    {
      "sub": "国家安全教育",
      "tec": "李进",
      "week": "9-12周",
      "add": "教学楼D座417文法"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
